import { observer } from 'mobx-react-lite';
import { PrizeModal } from './prizeModal';
import { ITaskConfig, QuestRewardTypes, QuestTypes, ShortLinkType } from 'src/types';
import { useStoreContext } from 'store/app';
import { ModalProps } from './modal';
import { useTranslationsContext } from 'store/translations';
import { useNavigate } from 'react-router';
import { routes } from 'utils/router';
import { useEffect, useState } from 'react';
import { ProviderDetailsModal } from './rewardsModal/providerDetailsModal';

interface Props extends ModalProps {
    mission: ITaskConfig;
}

export const QuestInfoModal = observer(({ mission, isOpened, onClose }: Props) => {
    const [isProviderModalOpened, setIsProviderModalOpened] = useState(false);
    const { openLink, completeQuest, showToast, logOperation, setCheckOverlays } = useStoreContext();
    const { translate } = useTranslationsContext();
    const navigate = useNavigate();
    const {
        modalButtonText,
        modalDescription,
        modalHeaderBg,
        modalTitle,
        modalHeaderImg,
        newYearType,
        actionLink,
        key,
        questCompletePrompt,
        rewardType,
        providerText,
        providerLink
    } = mission;

    useEffect(() => {
        isOpened && logOperation('tasks', 'task_view', key);
    }, [isOpened]);

    const onButtonClick = async () => {
        logOperation('tasks', 'task_open', key);
        if (newYearType === QuestTypes.INTERNAL) {
            openLink(actionLink!, false, { type: ShortLinkType.MISSION, subtype: key });
        }

        if (newYearType === QuestTypes.LINK) {
            openLink(actionLink!, true);
            await completeQuest(key);
            showToast(questCompletePrompt || translate('quest.complete'));
            if (rewardType === QuestRewardTypes.SNAKE_2025_LOOTBOX) {
                setCheckOverlays(true);
            } else {
                navigate(routes.wheel, { state: { missionId: key } });
            }
        }
    };

    const getButtonSecondaryTitle = () => {
        if (providerText || providerLink) return translate('reward.details.button.promo-provider');

        return undefined;
    };

    const onSecondaryButtonClick = () => {
        if (providerText) {
            setIsProviderModalOpened(true);
        }

        openLink(providerLink!, true, { type: ShortLinkType.MISSION, subtype: key });
    };

    return (
        <>
            <PrizeModal
                isOpened={isOpened}
                background={modalHeaderBg!}
                imgSrc={modalHeaderImg}
                title={modalTitle || ''}
                description={modalDescription}
                primaryButtonText={modalButtonText}
                secondaryButtonText={getButtonSecondaryTitle()}
                onClickSecondaryBtn={onSecondaryButtonClick}
                onClickPrimaryBtn={onButtonClick}
                onClose={onClose}
            ></PrizeModal>
            {isProviderModalOpened ? (
                <ProviderDetailsModal
                    text={providerText || ''}
                    missionId={mission.key}
                    isOpened={isProviderModalOpened}
                    onClose={() => {
                        setIsProviderModalOpened(false);
                    }}
                />
            ) : null}
        </>
    );
});
